import ZoneIcon from "./icons/zone";
import LocationIcon from "./icons/location";
import AlternativeLocationIcon from "./icons/alternativeLocation";
import StartIcon from "./icons/start";
import EndIcon from "./icons/end";
import { COLORS } from "../../constants";

const markerIcons = {
  zone: {},
  location: {},
  alternativeLocation: {},
  start: {},
  end: {}
};

const icons = {
  zone: ZoneIcon,
  location: LocationIcon,
  alternativeLocation: AlternativeLocationIcon,
  start: StartIcon,
  end: EndIcon
};

export const imageMaker = (color, type) => {
  return (
    "data:image/svg+xml;charset=utf-8;base64," +
    btoa(icons[type](color)) // btoa(unescape(encodeURIComponent(icons[type](color))))
  );
};

COLORS.forEach((color) => {
  ["zone", "location", "alternativeLocation", "start", "end"].forEach((type) => {
    markerIcons[type][color] = imageMaker(`#${color}`, type);
  });
});

export default markerIcons;
